// Shared ID generators.

// Generate an opaque device ID of the form 'dev-' + 8 hex chars, e.g.
// 'dev-9f3a1c2b'. Device IDs are never parsed for structure anywhere in the
// app — they are opaque primary/foreign keys — so a random value is safe.
// Must satisfy the backend's ID_RE (/^[A-Za-z0-9_-]{1,32}$/); the DB primary
// key + a 409 on POST /devices is the final collision backstop.
export function generateDeviceId() {
  const rand = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID().replace(/-/g, '')          // 32 hex chars
    : Math.random().toString(16).slice(2);           // fallback
  return 'dev-' + rand.padEnd(8, '0').slice(0, 8);
}
